import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { TerminationType } from 'features/call/call-base/enums';

export const sendZoomMeetingEnded = (
  terminationType: TerminationType,
  interpretTime: number
) => {
  const terminationString = TerminationType[terminationType];
  return sendAnalyticsInfo({
    Method: 'handleZoomMeetingEnded',
    LogGroup: 'Zoom',
    TerminationType: terminationString,
    InterpretTime: interpretTime,
    Message: `Zoom meeting ended with termination type ${terminationString} and interpret time ${interpretTime}`,
  });
};
